import { ReactNode, RefObject, useLayoutEffect, useState } from 'react'

export function useTextOverflow(elementRef: RefObject<HTMLElement>, content: ReactNode): boolean {
  const [overflowing, setOverflowing] = useState(false)

  useLayoutEffect(() => {
    const el = elementRef.current
    if (!el) {
      return
    }

    const checkOverflow = (): void => {
      if (el.scrollWidth > el.clientWidth) {
        setOverflowing(true)
        return
      }
      const range = document.createRange()
      range.selectNodeContents(el)
      const textWidth = range.getBoundingClientRect().width
      const containerWidth = el.getBoundingClientRect().width
      setOverflowing(textWidth > containerWidth + 0.1)
    }

    checkOverflow()
    const timer = setTimeout(checkOverflow, 100)

    const resizeObserver = new ResizeObserver(checkOverflow)
    resizeObserver.observe(el)
    if (el.parentElement) {
      resizeObserver.observe(el.parentElement)
    }

    return () => {
      clearTimeout(timer)
      resizeObserver.disconnect()
    }
  }, [elementRef, content])

  return overflowing
}
